import React, { useContext, useEffect, useRef } from "react"
import VideoTrack from "~/components/twilio/VideoTrack"
import { LocalTracksContext } from "~/components/twilio/LocalTracksProvider"
import { VideoContext } from "~/components/twilio/VideoProvider"
import { VideoQuality } from "~/components/twilio/VideoProvider"
import type { VideoPlayer, Participant } from "@zoom/videosdk"
interface PublicationProps {
  userInfo: Participant
  quality?: VideoQuality
  isMain: boolean
}

export default function Publication({
  userInfo,
  quality = VideoQuality.Video_360P,
  isMain,
}: PublicationProps) {
  const videoRef = useRef<HTMLDivElement | null>(null)
  const { videoEnabled } = useContext(LocalTracksContext)
  const { mediaStream, client } = useContext(VideoContext)
  const isLocal = client?.getCurrentUserInfo()?.userId === userInfo?.userId

  useEffect(() => {
    const renderVideo = async () => {
      if (videoRef.current) {
        // Clear existing children
        videoRef.current.innerHTML = ""

        if (mediaStream && client && userInfo?.bVideoOn) {
          // Gọi attach từ Zoom SDK
          const userVideo = await mediaStream.attachVideo(userInfo.userId, quality)
          if (!userVideo || "reason" in userVideo) {
            console.error("Failed to attach video", userVideo)
            return
          }
          userVideo.style.height = "100%"
          userVideo.style.width = "100%"
          userVideo.style.aspectRatio = "unset"
          userVideo.style.objectFit = "cover"
          // Gắn video
          videoRef.current.appendChild(userVideo as VideoPlayer)
        }
      }
    }

    renderVideo()

    // Optional: Clean up khi component unmount hoặc userId thay đổi
    return () => {
      if (videoRef.current) {
        videoRef.current.innerHTML = ""
      }
    }
  }, [videoEnabled, mediaStream, client, userInfo?.userId, userInfo?.bVideoOn])

  return (
    <VideoTrack videoRef={videoRef} userId={userInfo?.userId} isLocal={isLocal} isMain={isMain} />
  )
}
